import { useState, useEffect } from 'react';
import { Box, Image, Flex } from '@chakra-ui/react';

const StorySlider = ({ images }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [progress, setProgress] = useState(0);
  const duration = 5000; // Время показа одного изображения (в миллисекундах)
  const progressStep = 100 / (duration / 100); // Шаг изменения ширины прогресс-бара

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prev) => (prev < 100 ? prev + progressStep : 0));
    }, 100);

    const timeout = setTimeout(() => {
      nextImage();
    }, duration);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [currentIndex]);

  const nextImage = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex + 1 < images.length ? prevIndex + 1 : 0
    );
    setProgress(0);
  };

  const prevImage = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex - 1 >= 0 ? prevIndex - 1 : images.length - 1
    );
    setProgress(0);
  };

  return (
    <Box className="story-slider" position="relative" w="100%" h="100vh" bg="black"
      >
      { images.length > 1 &&
        <Flex position="absolute" top="16px" width="60%"
          left="50%"
          zIndex="999"
          transform="translate(-50%, 7px)" right="0" px={4} gap={2}>
          {images.map((_, index) => (
            <Box
              key={index}
              h="2px"
              borderRadius="2px"
              flex="1"
              bg={index < currentIndex ? 'white' : 'gray.500'}
              transition="width 0.1s linear"
              position="relative"
              overflow="hidden"
            >
              {index === currentIndex && (
                <Box
                  position="absolute"
                  h="100%"
                  bg="white"
                  w={`${progress}%`}
                  transition="width 0.1s linear"
                />
              )}
            </Box>
          ))}
        </Flex>
      }

      {/* Изображение */}
      <Image
        src={images[currentIndex]}
        w="100%"
        h="100%"
        objectFit="cover"
        onClick={nextImage} // Клик по картинке = следующее изображение
      />

      {/* Кнопки влево/вправо */}
      <Box
        position="absolute"
        top="0"
        left="0"
        w="50%"
        h="100%"
        onClick={prevImage}
        cursor="pointer"
      />
      <Box
        position="absolute"
        top="0"
        right="0"
        w="50%"
        h="100%"
        onClick={nextImage}
        cursor="pointer"
      />
    </Box>
  );
};

export default StorySlider;
